import { doc, writeBatch } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqGroupDataToUpdate } from "../types";

type Data = {
  [faqGroupId: string]: FaqGroupDataToUpdate;
};

export const bulkUpdateOrdering = async (data: Data): Promise<void> => {
  const batch = writeBatch(db);

  Object.entries(data).forEach(([faqId, faqGroupData]) => {
    const docRef = doc(db, `faqGroups/${faqId}`);
    batch.update(docRef, faqGroupData);
  });

  await batch.commit();
};
